import React from 'react';

export default function Controls({
  playerName,
  playerNumber,
  playerPosition,
  onNameChange,
  onNumberChange,
  onPositionChange,
  onOpenCamera,
  onDownload,
  isDownloading,
  downloadDisabled,
}) {
  return (
    <div className="pcg-controls">
      <div>
        <label htmlFor="pcg-name" className="pcg-field-label">
          Player name
        </label>
        <input
          id="pcg-name"
          type="text"
          value={playerName}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="e.g. Alex Gladiator"
          autoComplete="off"
          className="pcg-input"
        />
      </div>

      <div className="pcg-row-2">
        <div>
          <label htmlFor="pcg-number" className="pcg-field-label">
            Number
          </label>
          <input
            id="pcg-number"
            type="text"
            inputMode="numeric"
            value={playerNumber}
            onChange={(e) => onNumberChange(e.target.value)}
            placeholder="99"
            className="pcg-input"
          />
        </div>
        <div>
          <label htmlFor="pcg-position" className="pcg-field-label">
            Position
          </label>
          <input
            id="pcg-position"
            type="text"
            value={playerPosition}
            onChange={(e) => onPositionChange(e.target.value)}
            placeholder="C / D / G"
            className="pcg-input"
          />
        </div>
      </div>

      <div>
        <span className="pcg-head-block-title">Head photo</span>
        <p className="pcg-head-hint">Use your camera for a selfie, then crop to your head.</p>
        <div className="pcg-modal-stack">
          <div className="pcg-btn-row">
            <button
              type="button"
              onClick={onOpenCamera}
              disabled={isDownloading}
              className="pcg-btn-camera"
            >
              Use camera
            </button>
          </div>
          <span className="pcg-footnote">
            The camera needs a secure page (HTTPS or localhost). Dark backgrounds around your head are softened
            automatically; very busy backgrounds may need a tighter crop.
          </span>
        </div>
      </div>

      <button type="button" onClick={onDownload} disabled={downloadDisabled} className="pcg-dl-btn">
        {isDownloading ? 'Preparing download…' : 'Download My Player Card'}
      </button>
    </div>
  );
}
